<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('label.company')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                disabled
                type="list"
                v-decorator="['companyCode', {'initialValue': initCompanyCode, rules: validatorRules.companyCode.rules}]" :trigger-change="true" dictCode="sys_depart,depart_name,org_code,org_category='1' and del_flag='0'"  :placeholder="$t('label.pleaseSelectCompany')"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item :label="$t('label.date')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectTheDate')" v-decorator="['dailyTime', {'initialValue': initDailyTime, rules: validatorRules.dailyTime.rules}]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.species')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['breedClassCode',validatorRules.breedClassCode]" :trigger-change="true" dictCode="sys_category,name,code,pid=(select id from sys_category where code='A01' AND name = '物种分类')" :placeholder="$t('label.pleaseSelectCategory')"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.chickenPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['dailyPrice',validatorRules.dailyPrice]" :placeholder="$t('label.pleaseEnterTheDailyPrice')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item v-has="'code'" :label="$t('label.number')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['code']" :placeholder="$t('label.pleaseEnterTheNumber')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item v-has="'breedVarietyCode'" :label="$t('label.strain')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['breedVarietyCode']" :trigger-change="true" dictCode="" :placeholder="$t('label.pleaseSelectTheStrain')"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['remark']" placeholder="请输入备注"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('remark')" :popLists="getMainTablePop('remark')">
                <a-input
                  v-decorator="['remark']"
                  :read-only="whetherLang('remark')"
                  @click="isLangClick('remark', false)"
                  :placeholder="$t('label.pleaseEnterANote')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <mtc-lang-modal/>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import moment from 'moment'
  import { getCurrentUser } from '@api/api'
  import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'


  export default {
    name: 'EfsMdChickenPriceForm',
    mixins: [mtcLangModalMixin],
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        mainTable: 'efs_md_chicken_price',
        // form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          companyCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterCompany')},
            ]
          },
          dailyTime : {
           rules: [
              { required: true, message: '请输入日期!'},
            ]
          },
          dailyPrice: {
            rules: [
              { required: true, message: '请输入价格!'},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          breedClassCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheBreed')},
            ]
          },
        },
        url: {
          add: "/chickenPrice/efsMdChickenPrice/add",
          edit: "/chickenPrice/efsMdChickenPrice/edit",
          queryById: "/chickenPrice/efsMdChickenPrice/queryById"
        },
        initCompanyCode: null,
        initDailyTime: moment(new Date()).format('YYYY-MM-DD'),
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
      getCurrentUser().then((res) => {
        if (res.success) {
          this.initCompanyCode = res.result.orgCode;
        }
      });
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'code','companyCode','dailyTime','breedClassCode','breedVarietyCode','dailyPrice','remark'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'code','companyCode','dailyTime','breedClassCode','breedVarietyCode','dailyPrice','remark'))
      },
    }
  }
</script>